export class UrlHelperService {
    static menu = 'menu';
    static content = 'page';
    static contentGetPageByMenuId = 'page/GetPageByMenuId';
    static home = 'home';
    static features = 'feature';
    static stream ='stream';
    static blogs ='Blogs';
    static news ='news';
    static CustomForm ='customform';
    static getCustomFormblogs='blogs/getCustomForm';
    static controlType='customFormControl/getcontroltype';
    static SelectedCustomForm ='customform/GetCustomFormByPageType';
    static SelectedCustomFormbypage ='customform/GetCustomFormByMenuId';
    static SaveCustomFormValue='CustomFormValue';
    static getTools='tools';
    static getTournament='tournament';
    static getLeague='Leagues';
  
    
}